import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import {cartList, cartUpdate, cartDelete} from '@/api/server/cart'
import commonMixin from '@/mixin/common'
export default {
  name: 'cartPage',
  mixins: [commonMixin],
  data () {
    return {
      list: [],
      total: []
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent
  },
  methods: {
    onSubmit () {
      if (!this.list || this.list.length < 1) {
        this.error('您的购物车还没有商品')
        return false
      } else {
        this.$router.push({name: 'order'})
      }
    },
    onDelete (item) {
      if (!item.id) {
        return false
      }
      cartDelete([item.id]).then( (data) => {
        this._resetCart(data)
      })
    },
    changeNumber (item) {
      cartUpdate(item.id, item.number).then( (data) => {
        this._resetCart(data)
      })
    },
    _getList () {
      let query = {
      }
      cartList(query).then((data) => {
        // if (data.code === 200 && data.data) {
        //     this.list = data.data.list
        //     this.total = data.data.cartTotal
        // } else {
        //     this.warning(data.message)
        // }
        this._resetCart(data)
      }).catch((e) => {
        console.log('err', e)
      })
    },
    _resetCart (data) {
      if (data.code === 200 && data.data) {
        this.list = data.data.list
        this.total = data.data.cartTotal
      } else {
          this.warning(data.message)
      }
    },
    reset () {
      this.list = []
      this.total = []
      this._getList()
    },
    handleRoute (route) {
      if (route.name === 'cart') {
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}